const phoneInputPattern = /^\+?[\d\s()-]+$/;

export function isPhoneLike(value: string) {
  const trimmed = value.trim();
  const digits = trimmed.replace(/\D/g, '');
  const plusCount = (trimmed.match(/\+/g) ?? []).length;

  return (
    trimmed.length > 0 &&
    phoneInputPattern.test(trimmed) &&
    plusCount <= 1 &&
    (!trimmed.includes('+') || trimmed.startsWith('+')) &&
    digits.length >= 10 &&
    digits.length <= 15
  );
}
